import toast from "react-hot-toast";
import {
  PERSONAL_SHOPPER_LIST_2,
  PERSONAL_SHOPPER_LIST_SUCCESS_2,
  PERSONAL_SHOPPER_LIST_FAIL_2,
  THREAD_USER,
  THREAD_USER_SUCCESS,
  THREAD_USER_FAIL,
  THREAD_CHAT,
  THREAD_CHAT_SUCCESS,
  THREAD_CHAT_SUCCESS_FAIL,
  PERSONAL_SHOPPER_ITEMS_LIST,
  PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS,
  PERSONAL_SHOPPER_ITEMS_LIST_FAIL,
  PERSONAL_SHOPPER_DROP_DOWN_LIST,
  PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS,
  PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL,
 
} from "../actions/PersonalShopperActions";

const initialState = {
  isLoading: false,
  /** Tickets list on /personal-shopper — separate from `isLoading` (thread/chat also use that flag). */
  isPersonalShopperItemsListLoading: false,
  hasFetchedPersonalShopperItemsList: false,
  /** Customer ticket list (`PERSONAL_SHOPPER_LIST_2`) — same separation as items list. */
  isPersonalShopperList2Loading: false,
  hasFetchedPersonalShopperList2: false,
  isError: false,
  isSuccess: false,
  message: "",
  personalShopList: [],
  threadUser: {},
  chatThread:[],
  personalShopperItemsList: [],
  personalShopperDropDownList: [],

};
const personalShopperReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case PERSONAL_SHOPPER_LIST_2: {
      return {
        ...state,
        isPersonalShopperList2Loading: true,
      };
    }
    case PERSONAL_SHOPPER_LIST_SUCCESS_2: {
      return {
        ...state,
        personalShopList: payload?.data,
        isPersonalShopperList2Loading: false,
        hasFetchedPersonalShopperList2: true,
        isLoading: false,
      };
    }

    case PERSONAL_SHOPPER_LIST_FAIL_2: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isPersonalShopperList2Loading: false,
        hasFetchedPersonalShopperList2: true,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error?.data?.message,
      };
    }

    case THREAD_USER: {
    return {
      ...state,
      isLoading: true,
      };
    }
    case THREAD_USER_SUCCESS: {
      return {
        ...state,
        threadUser:payload.data,
        isLoading: false,
      };
    }
    case THREAD_USER_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error?.data?.message,
      };
    }

    case THREAD_CHAT: {
      return {
        ...state,
        isLoading: true,
        };
    }
    case THREAD_CHAT_SUCCESS: {
      return {
        ...state,
        chatThread:payload.data,
        isLoading: false,
      };
    }
    case THREAD_CHAT_SUCCESS_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error?.data?.message,
      };
    }

    case PERSONAL_SHOPPER_ITEMS_LIST: {
      return {
        ...state,
        isPersonalShopperItemsListLoading: true,
      };
    }
    case PERSONAL_SHOPPER_ITEMS_LIST_SUCCESS: {
      return {
        ...state,
        personalShopperItemsList: payload.data,
        isPersonalShopperItemsListLoading: false,
        hasFetchedPersonalShopperItemsList: true,
        isLoading: false,
      };
    }

    case PERSONAL_SHOPPER_ITEMS_LIST_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isPersonalShopperItemsListLoading: false,
        hasFetchedPersonalShopperItemsList: true,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error?.data?.message,
      };
    }

        case PERSONAL_SHOPPER_DROP_DOWN_LIST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case PERSONAL_SHOPPER_DROP_DOWN_LIST_SUCCESS: {
      return {
        ...state,
        personalShopperDropDownList:payload.data.data,
        isLoading: false,
      };
    }

    case PERSONAL_SHOPPER_DROP_DOWN_LIST_FAIL: {
      toast.error(payload?.error?.data?.message);
      return {
        ...state,
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: payload?.error?.data?.message,
      };
    }
    default: {
      return { ...state };
    }
  }
};
export default personalShopperReducer;
